var Component = require("/home/travis/build/tonyhhyip/library/node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel!./../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Suggestion.vue"),
  /* template */
  require("!!./../../../node_modules/vue-loader/lib/template-compiler?id=data-v-1bcc4586!./../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Suggestion.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./assets/js/page/Suggestion.vue
// module id = 66
// module chunks = 0